import { Component, OnInit, Input, ViewChild, Inject } from '@angular/core';
import { TCCPCommonService } from '../../services/tccp-common.service';
import { environment } from '../../../../environments/environment';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatCheckbox, MatCheckboxChange } from '@angular/material/checkbox';
import { AdminService } from '../../../admin/admin.service';

@Component({
  selector: 'app-preview-image',
  templateUrl: './preview-image.component.html',
  styleUrls: ['./preview-image.component.scss']
})
export class PreviewImageComponent implements OnInit {
  public contentType: string = null;
  public imageInfo;
  public selectedImageList = [];
  public imageList = [];
  public selectedFeatureIcon = {};
  pageEvent: PageEvent;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;

  constructor(public commonService: TCCPCommonService,
              public dialogRef: MatDialogRef<PreviewImageComponent>, private adminService: AdminService,
              @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  // MatPaginator Inputs
  imageListLength = 100;
  imageListPageSize = 10;
  imageListPageSizeOptions: number[] = [5, 10, 25, 100];

  page = 1;
  count = 0;
  pageSize = 20;
  pageSizes = [10, 20, 100];

  // MatPaginator Output

  setPageSizeOptions(setPageSizeOptionsInput: string) {
    if (setPageSizeOptionsInput) {
      this.imageListPageSizeOptions = setPageSizeOptionsInput.split(',').map(str => +str);
    }
  }

  close(): void {
    this.dialogRef.close();
  }

  ngOnInit() {
    this.imageInfo = this.data.type;
    this.contentType = 'internal';
    this.getImageList();
  }

  onContentTypeChange(event) {
    this.getImageList();
  }

  onImageClick(imageName, index, event?) {
    this.selectedFeatureIcon = this.imageList[index];
    if (this.imageInfo === 'step') {
      if (event.checked) {
        this.selectedImageList.push(imageName.image);
      } else {
        const imageIndex = this.selectedImageList.indexOf(imageName.image);
        if (imageIndex > -1) {
          this.selectedImageList.splice(imageIndex, 1);
        }
      }
    } else {
      this.selectedImageList = [];

      if (event.checked) {
        this.selectedImageList.splice(0, 1, imageName.image);
        this.imageList.forEach((x, i) => {
          if (i !== index) {
            x.checked = false ;
          }

        });
      } else {
        const imageIndex = this.selectedImageList.indexOf(imageName.image);

        if (imageIndex > -1) {
          this.selectedImageList.splice(imageIndex, 1);
        }
      }
      /* const radioBtnElement = document.getElementById('radio' + index);
      if (event !== undefined && event.checked) {
        radioBtnElement['checked'] = true;
        this.imageList[index].checked = true;
        this.selectedImageList = [];
        this.selectedImageList.push(imageName.image);
      } else {
        this.selectedImageList = [];
        radioBtnElement['checked'] = false;
      } */
    }
  }

  getRequestParams(searchTitle, page, pageSize) {
    // tslint:disable-next-line:prefer-const
    let params = {};

    if (searchTitle) {
      params[`title`] = searchTitle;
    }

    if (page) {
      params[`page`] = page - 1;
    }

    if (pageSize) {
      params[`size`] = pageSize;
    }

    return params;
  }

  getImageList() {
    this.imageList = [];
    const featureType = this.contentType.toLowerCase();
    const type = this.imageInfo;
    this.commonService.getImageList(featureType, type).subscribe(response => {
      if (response) {
        if (type === 'Feature') {
          if (response && response.Items) {
            response.Items.forEach(x => {
              if (x.featureType === this.contentType) {
                if (x.controls && x.controls.length > 0) {
                  this.imageList.push({ image: environment.baseURL + x.controls[0].icon, checked: false });
                }
              }
            });
          }
        } else {
          const imageArray = response && response.Items.map(x => x.imagesOrVideos.map(y => { return y }));
          if (response && response.Items) {
            response.Items.forEach(x => {
              if (x.imagesOrVideos && x.imagesOrVideos.length > 0) {
                x.imagesOrVideos.forEach(y => {
                  this.imageList.push({ image: environment.baseURL + y, checked: false });
                });
              }
            });
          }
        }
      }
    });
  }

  handlePageChange(event) {
    this.page = event;
    this.imageList.forEach((x, index) => {
      if (this.selectedImageList.indexOf(x.image) > -1) {
        if (this.imageInfo === 'step') {
          this.imageList[index].checked = true;
        }
        if (this.imageInfo === 'Feature') {
          this.imageList[index].checked = true;
        }
        /* setTimeout(() => {
          if (this.imageInfo === 'Feature') {
            const radioBtnElement = document.getElementById('radio' + index);
            radioBtnElement['checked'] = true;
            this.imageList[index].checked = true;
            // this.selectedFeatureIcon = this.imageList[index];
            return;
          }
        }, 500); */
      }
    });
  }

  handlePageSizeChange(event) {
    this.pageSize = event.target.value;
    this.page = 1;
  }

  onSelect() {
    this.dialogRef.close({ event: 'save', data: this.selectedImageList });
  }

  onCancel() {
    this.dialogRef.close();
  }

}
